import request from "src/api/request-manager/gateway";

import type {
  InfoUserResponse,
  SendEmailConfirmationData,
  SendOTPAuthData,
  SendPhoneNumberVerificationData,
  SubmitVerificationData,
  UpdateCompanyData,
  UpdateDocumentData,
  UpdatePersonalData,
  VerificationInfoResponse,
  VerifyEmailData,
  VerifyOTPAuthData,
  VerifyPhoneNumberData
} from "./types/verification.types";

const userPrefixURL = "/dashboard/v1/user";
const companyPrefixURL = "/dashboard/v1/company";

const customHead = { "content-type": "multipart/form-data" };

const VerificationAPI = {
  verificationInfo(): Promise<VerificationInfoResponse> {
    return request.get<VerificationInfoResponse>(`${userPrefixURL}/verification-info`);
  },
  infoUser(): Promise<InfoUserResponse> {
    return request.get<InfoUserResponse>(`${userPrefixURL}/info`);
  },
  sendEmailConfirmation(data: SendEmailConfirmationData) {
    return request.post(`${userPrefixURL}/send-email-confirmation`, data);
  },
  verifyUserEmail(data: VerifyEmailData) {
    return request.post(`${userPrefixURL}/verify-email`, data);
  },
  sendPhoneNumberVerification(data: SendPhoneNumberVerificationData) {
    return request.post(`${userPrefixURL}/send-phone-number-verification`, data);
  },
  verifyPhoneNumber(data: VerifyPhoneNumberData) {
    return request.post(`${userPrefixURL}/verify-phone-number`, data);
  },
  sendOTPAuth(data: SendOTPAuthData, token: string) {
    return request.post(`${userPrefixURL}/send-otp-auth`, data, { Authorization: `Bearer ${token}` });
  },
  verifyOTPAuthTrustedDevice(data: VerifyOTPAuthData, token: string) {
    return request.post(`${userPrefixURL}/verify-otp-auth`, data, { Authorization: `Bearer ${token}` });
  },
  updateCompanyData(data: UpdateCompanyData) {
    return request.put(`${companyPrefixURL}/update-company-data`, data);
  },
  updatePersonalData(data: UpdatePersonalData) {
    return request.put(`${companyPrefixURL}/update-personal-data`, data);
  },
  updateDocumentData(data: UpdateDocumentData) {
    return request.post(`${companyPrefixURL}/update-document-data`, data, customHead);
  },
  submitVerification(data: SubmitVerificationData) {
    return request.post(`${companyPrefixURL}/submit-verification`, data);
  }
};

export default VerificationAPI;
